"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("gasparesganga-jquery-loading-overlay");
(function (w, $) {
    if (!$)
        return false;
    var showLoaderExtension = {
        showLoader: function (ms) {
            if (ms === void 0) { ms = 500; }
            return this.each(function () {
                var element = $(this);
                if (element.data('timeOutId'))
                    return;
                var loaderOverride = $('#custom-loading-indicator');
                if (loaderOverride.length) {
                    LoaderSettings.custom = loaderOverride.html();
                }
                var delayId = setTimeout(function () {
                    element.LoadingOverlay('show', LoaderSettings);
                }, ms);
                element.data('timeOutId', delayId);
            });
        }
    };
    $.fn.extend(showLoaderExtension);
    var hideLoaderExtention = {
        hideLoader: function () {
            return this.each(function () {
                var element = $(this);
                element.LoadingOverlay('hide');
                clearTimeout(element.data('timeOutId'));
                element.removeData('timeOutId');
            });
        }
    };
    $.fn.extend(hideLoaderExtention);
})(window, $);
var LoaderSettings = {
    image: '',
    custom: "<svg class=\"circular\" viewBox=\"25 25 50 50\"><circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/></svg>"
};
